import React from 'react';

import WidgetInput from './WidgetInput';

import PropsStatic from './interfaces/PropsStaticInterface';

export default class WidgetStatic extends WidgetInput<PropsStatic> {
    trustedHtml() {
        return { __html: this.props.text };
    }

    render() {
        let extraProps = {
            className: this.props.class || '',
        };
        if (this.props['data-dynamic-price']) {
            // @ts-ignore
            extraProps['data-dynamic-price'] = this.props['data-dynamic-price'];
        }
        return React.createElement(
            'div',
            extraProps,
            <div dangerouslySetInnerHTML={this.trustedHtml()}></div>
        );
    }
}
